<template>
    <div>
        <div class="sousuo">
            <div class="sou-item">
                <van-search
                        v-model="phone"
                        placeholder="请输入手机号搜索"
                        show-action
                        shape="round"
                >
                    <div slot="action" @click="onSearch">搜索</div>
                </van-search>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <div style="margin-top: 10px">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="oo-items" v-for="(item,index) in list">
                    <div class="mbinfo">
                        <div>
                            <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                            <div v-else>
                                <img v-if="item.sex==0" src="./../../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==1" src="./../../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==2" src="./../../../assets/nv.png" class="my-tou"/>
                            </div>
                        </div>
                        <div class="my-mbinfo">
                            <span>{{item.memberName}}</span>
                        </div>
                    </div>
                    <div class="ooinfo">
                        <div class="ooinfo-item">
                            <span class="oi-name">订单编号</span>
                            <span class="oi-val">{{item.orderNo}}</span>
                        </div>
                        <div class="ooinfo-item">
                            <span class="oi-name">购买时间</span>
                            <span class="oi-val">{{item.createTime}}</span>
                        </div>
                        <div class="ooinfo-item">
                            <span class="oi-name">商品名称</span>
                            <span class="oi-val">{{item.skuName}}</span>
                        </div>
                        <div class="ooinfo-item">
                            <span class="oi-name">手机号</span>
                            <span class="oi-val">{{item.phone}}</span>
                        </div>
                        <div class="ooinfo-item">
                            <span class="oi-name">推荐人</span>
                            <span class="oi-val">{{item.superiorName}}</span>
                        </div>
                    </div>
                    <div class="oi-btn">
                        <van-button type="default" class="oi-bi1" v-if="item.isSettlement==0" @click="toJs(item,index)">
                            待结算
                        </van-button>
                        <!--                        <van-button type="default" class="oi-bi3" v-if="item.isSettlement==1"-->
                        <!--                                    @click="toYjs(item,index)">-->
                        <!--                            已结算-->
                        <!--                        </van-button>-->
                        <van-button type="default" class="oi-bi2" @click="toInfo(item)">订单详情</van-button>
                    </div>
                </div>
            </van-list>
        </div>
        <van-popup v-model="xqShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>订单详情</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="oo-items">
                <div class="mbinfo" style="border-bottom: #C0BEC0 solid 0px;">
                    <div>
                        <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                        <div v-else>
                            <img v-if="item.sex==0" src="./../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==1" src="./../../../assets/nan.png" class="my-tou"/>
                            <img v-if="item.sex==2" src="./../../../assets/nv.png" class="my-tou"/>
                        </div>
                    </div>
                    <div class="my-mbinfo">
                        <span>{{item.memberName}}</span>
                        <span>{{item.phone}}</span>
                    </div>
                </div>
                <div class="ooinfo">
                    <div class="ooinfo-item">
                        <span class="oi-name">订单编号:</span>
                        <span class="oi-val">{{item.orderNo}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">购买时间:</span>
                        <span class="oi-val">{{item.createTime}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">商品名称:</span>
                        <span class="oi-val">{{item.skuName}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">推荐人:</span>
                        <span class="oi-val">{{item.superiorName}}</span>
                        <span class="oi-val1" v-if="item.superiorName">收益:<span
                                style="color:#F58638;"> ¥{{item.zjCmn}}</span></span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">间接推荐人:</span>
                        <span class="oi-val">{{item.indirectName}}</span>
                        <span class="oi-val1" v-if="item.indirectName">收益:<span
                                style="color:#F58638;"> ¥{{item.jjCmn}}</span></span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">事业部:</span>
                        <span class="oi-val">{{item.bmName}}</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">负责人:</span>
                        <span class="oi-val">{{item.bmFounder}}</span>
                        <span class="oi-val1" v-if="item.bmFounder">收益:<span
                                style="color:#F58638;"> ¥{{item.frCmn}}</span></span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">支付方式:</span>
                        <span class="oi-val" v-if="item.payType==0">微信支付</span>
                        <span class="oi-val" v-if="item.payType==2">金豆支付</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">配送方式:</span>
                        <span class="oi-val" v-if="item.shippingType==0">到店</span>
                        <span class="oi-val" v-if="item.shippingType==1">快递</span>
                    </div>
                    <div class="ooinfo-item">
                        <span class="oi-name">订单状态:</span>
                        <span class="oi-val" v-if="item.orderStatus==1">待发货</span>
                        <span class="oi-val" v-if="item.orderStatus==2">已发货</span>
                        <span class="oi-val" v-if="item.orderStatus==3">已完成</span>
                    </div>
                </div>
                <div>
                    <span class="odbt">订单内容</span>
                    <div style=" margin: 0 18px;">
                        <div class="goodsitem" v-for="goods in item.goodsItems">
                            <span>{{goods.itemName}}</span>
                            <span>x{{goods.total}}</span>
                        </div>
                        <div style="font-size: 13px;margin-top: 12px">
                            订单金额:<span style="margin-left: 18px">¥{{item.payPrice}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="djsShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;overflow:hidden;padding-bottom: 50px">
             <span class="md-bt">
                    <span>待结算</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="oo-items">
                <div class="ooinfo">
                    <span style="font-size: 13px;display: block" v-if="item.isFz==0||item.isFz==1">分账订单,最大分账金额为：¥{{fzbz}}</span>
                    <span style="font-size: 13px;display: block" v-if="item.isFz==2">转账订单,无任何限制金额</span>
                </div>
                <div class="ooinfo">
                    <div class="xtr" v-if="item.superiorName">
                        <div class="ooinfo-item1">
                            <span class="oi-name1">推荐人</span>
                            <div class="ooinfo-item">
                                <span class="oi-val">{{item.superiorName}}</span>
                                <span class="oi-val1" v-if="item.superiorName">收益:<span
                                        style="color:#F58638;"> ¥{{item.zjCmn}}</span></span>
                            </div>
                            <div class="ooinfo-item2">
                                <el-radio-group v-model="zjRadio">
                                    <el-radio :label="1">分账</el-radio>
                                    <el-radio :label="2">微信转账</el-radio>
                                    <el-radio :label="3">支付宝转账</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="xtr" v-if="item.indirectName">
                        <div class="ooinfo-item1">
                            <span class="oi-name1">间接推荐人</span>
                            <div class="ooinfo-item">
                                <span class="oi-val">{{item.indirectName}}</span>
                                <span class="oi-val1" v-if="item.indirectName">收益:<span
                                        style="color:#F58638;"> ¥{{item.jjCmn}}</span></span>
                            </div>
                            <div class="ooinfo-item2">
                                <el-radio-group v-model="jjRadio">
                                    <el-radio :label="1">分账</el-radio>
                                    <el-radio :label="2">微信转账</el-radio>
                                    <el-radio :label="3">支付宝转账</el-radio>
                                </el-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="xtr" v-if="item.bmFounder">
                        <div class="ooinfo-item">
                            <span class="oi-name">事业部</span>
                            <span class="oi-val">{{item.bmName}}</span>
                        </div>
                        <div class="ooinfo-item">
                            <span class="oi-val">{{item.bmFounder}}</span>
                            <span class="oi-val1" v-if="item.bmFounder">收益:<span
                                    style="color:#F58638;"> ¥{{item.frCmn}}</span></span>
                        </div>
                        <div class="ooinfo-item2">
                            <el-radio-group v-model="frRadio">
                                <el-radio :label="1">分账</el-radio>
                                <el-radio :label="2">微信转账</el-radio>
                                <el-radio :label="3">支付宝转账</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jsbtn" @click="toQr(item)">
                结算
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";
    import Cxdate from "./../../common/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '订单管理',
                fwUser: {},
                deptId: '',
                token: '',
                userType: '',
                dateType: 0,
                staDate: '',
                endDate: '',

                active: 0,
                phone: '',
                list: [],
                page: 1,
                loading: false,
                finished: false,

                xqShow: false,
                djsShow: false,
                orderId: '',
                item: {},
                fzbz: 0,

                zjRadio: 1,
                jjRadio: 1,
                frRadio: 1,
                delIndex: '',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
        },
        methods: {
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            onSearch() {
                this.list = []
                this.page = 1
                this.loading = false
                this.finished = false
                this.onLoad()
            },

            async onLoad() {
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    phone: this.phone,
                    isSettlement: this.active,
                    currentPage
                }
                let res = await this.$get("/fw/getFwShopOrderList", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            //订单详情
            async toInfo(item) {
                this.xqShow = true
                if (!this.item.id) {
                    let data = {
                        orderId: item.id
                    }
                    let res = await this.$get("/fw/getFwShopOrderInfo", data)
                    this.item = res.order
                }
            },

            async toJs(item, index) {
                this.delIndex = index
                if (item) {
                    this.orderId = item.id
                }
                this.djsShow = true
                if (!this.item.id) {
                    let data = {
                        orderId: this.orderId
                    }
                    let res = await this.$get("/fw/getFwShopOrderInfo", data)
                    this.item = res.order
                    this.fzbz = res.fzbz
                }
            },

            toQr(item) {
                let data = {
                    token: this.token,
                    orderId: item.id,
                    zjId: item.zjId,
                    jjId: item.jjId,
                    frId: item.frId,
                    zjRadio: this.zjRadio,
                    jjRadio: this.jjRadio,
                    frRadio: this.frRadio,
                }
                var that = this
                that.$dialog.confirm({
                    title: '标题',
                    message: '是否结算?'
                }).then(() => {
                    that.updateSettlement(data)
                }).catch(() => {
                    // on cancel
                });
            },

            async updateSettlement(data) {
                let res = await this.$post("/fw/fwUpdateSettlement", data)
                if (res.code == 200) {
                    this.$emit('setActive', 1)
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: '#1989fa'
                    });
                } else {
                    this.$notify({
                        message: res.message,
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            //去重
            quchong(arr, property) {
                const seen = new Set();
                return arr.filter(item => {
                    const key = item[property];
                    return !seen.has(key) && seen.add(key);
                });
            },

            guanbi() {
                this.xqShow = false
                this.djsShow = false
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-odfx {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F2F1F6;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 38px;
    }

    .xiantiao {
        border-bottom: #CAC6C7 solid 1px;
        height: 1px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px 10px 0 10px;
        border-bottom: #C0BEC0 solid 1px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .my-mbinfo span {
        font-size: 13px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 16px
    }

    .oo-items {
        background-color: #FFFFFF;
        margin: 10px;
        padding: 0 8px;
    }

    .ooinfo {
        padding: 8px 16px;
    }

    .ooinfo-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11px;
    }

    .ooinfo-item1 {
        display: flex;
        flex-direction: column;
        font-size: 11px;
    }

    .ooinfo-item2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11px;
    }

    .xtr {
        margin-bottom: 45px;
    }

    .oi-name {
        width: 78px;
        height: 35px;
        line-height: 35px;
    }

    .oi-name1 {
        width: 78px;
        height: 35px;
        line-height: 35px;
    }

    .oi-val {
        height: 35px;
        line-height: 35px;
        width: 45%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .oi-val1 {
        height: 35px;
        line-height: 35px;
        position: absolute;
        width: 100px;
        right: 5px;
    }

    .oi-fz {
        height: 22px;
        line-height: 20px;
        width: 30%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 10px 10px 0 10px;
        text-align: center;
        border: #e5e5e5 solid 1px;
        cursor: pointer;
    }

    .oi-fz1 {
        height: 22px;
        line-height: 20px;
        width: 100%;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #2b94ff;
    }

    .oi-btn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-top: 10px;
        padding-bottom: 20px;
    }

    .oi-bi1 {
        background-color: #FD99B0;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .oi-bi2 {
        background-color: #9086DF;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .oi-bi3 {
        background-color: #4B415E;
        width: 100px;
        height: 28px;
        color: #FFFFFF;
        border-radius: 5px;
        font-size: 12px;
        margin: 0 20px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .mmdd {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .odbt {
        display: block;
        font-size: 13px;
        margin: 0 14px;
        padding: 2px;
        border-bottom: #DDDCDD solid 1px;
    }

    .goodsitem {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 12px;
        height: 35px;
        line-height: 35px;
    }

    ::v-deep .el-radio__label {
        font-size: 10px;
        padding-left: 5px;
    }

    .jsbtn {
        background-color: #ee0a24;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 13px;
        color: #FFFFFF;
        width: 100%;
        position: absolute;
        bottom: 0px;
    }
</style>